<template>
  <div
    :class="{
      root: true,
      hover: hover || ($props.overlay ? $props.overlay.forceVisible : false),
    }"
    :style="{
      cursor: $props.overlay ? $props.overlay.cursor : false,
    }"
    @mouseover="hover = true"
    @mouseout="hover = false"
  >
    <div
      class="fixed-ratio bg-light"
      :style="{
        'padding-bottom': `${ratio}%`,
      }"
    >
      <img v-if="$props.withSpinner" src="../assets/ball.gif" class="loader" />
      <img v-lazy="$props.src" class="fixed-ratio-content" />

      <div class="title" v-if="$slots.title">
        <slot name="title" />
      </div>

      <slot />
    </div>
    <template v-if="$props.overlay">
      <div class="overlay" :style="{ background: $props.overlay.background }" />
      <div class="button">
        <template v-if="$slots.overlayButton">
          <slot name="overlayButton" />
        </template>
        <template v-else>
          <i :class="`text-white fa fa-${overlay.icon}`" aria-hidden="true" />
        </template>
      </div>
    </template>

    <div class="title" v-if="$slots.titleOver">
      <slot name="titleOver" />
    </div>

    <slot name="over" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'LazyImage',
  props: {
    src: {},
    height: { default: null },
    width: { default: null },
    overlay: {},
    withSpinner: {
      default: false,
    },
  },
  data() {
    return {
      hover: false,
    };
  },
  computed: {
    ratio() {
      return Math.ceil((this.$props.height / this.$props.width) * 100);
    },
  },
};
</script>

<style lange="scss" scoped>
.loader {
  width: 50px;
  height: 50px;

  position: absolute;
  top: 50%;
  left: 50%;

  margin: -25px 0 0 -25px;
}

.overlay {
  opacity: 0;
  background: rgba(0, 0, 0, 0.5);
  height: 100%;
  top: 0;
  left: 0;
  width: 100%;
  position: absolute;
}

.button {
  z-index: 1000;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  font-size: 20px;
}

.root {
  position: relative;
  height: 100%;
}

.root.hover .overlay {
  opacity: 0.8;
}

.root.hover .button {
  opacity: 0.9;
  font-size: 40px;
}

.title {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 15px;
  background-color: rgba(0, 0, 0, 0.4);
  color: rgb(231, 231, 231);
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/LazyImage.vue